import React from "react";

export default function AppletIcon({ url }: { url: string }) {
  return (
    <div
      className='tw-h-8 tw-w-8 tw-bg-[var(--primary-color,black)] [mask-image:var(--icon-url)] [mask-size:cover]'
      style={{ "--icon-url": `url('${url}')` } as React.CSSProperties}
    />
  );
}
